import Vue from 'vue'
import Vuex from 'vuex'
import tagsNav from './modules/tagsNav'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {},
    mutations: {},
    actions: {},
    modules: {
        tagsNav
    }
})


// WEBPACK FOOTER //
// ./src/store/index.js